<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import constants from "../../constants";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Edit Students",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Edit Students",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Manage Students",
          href: "/students",
        },
        {
          text: "Edit Students",
          active: true,
        },
      ],
      data: {
        name: "",
        photo: "",
        dob: "",
        gender: "",
        class: "",
        course: "",
        entryStatus: "",
        resident: "",
        gemail: "",
        gcontact: "",
        guardian: "",
        logid: "",
        stdContact: "",
        occupation: "",
        email: "",
        address: "",
      },
      errors: {
        name: "",
        photo: "",
        dob: "",
        gender: "",
        class: "",
        course: "",
        entryStatus: "",
        resident: "",
        gemail: "",
        gcontact: "",
        guardian: "",
        logid: "",
        stdContact: "",
        occupation: "",
        email: "",
        address: "",
      },
      sysConstants: constants,
    };
  },
  computed: {
    ...mapGetters("students", [
      "GetAllStudentsDetails",
      "SaveStatus",
      "AllStudents",
    ]),
    ...mapGetters("classes", ["CustomClasses", "AllCourses", "AllClasses"]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  mounted() {},
  watch: {
    SaveStatus(newVal) {
      if (!newVal) {
        this.resetError();
      }
    },
    GetAllStudentsDetails(newVal) {
      const courseSelected = {
        course: newVal.acc.course,
      };
      //fetching levels in course
      this.FetchCustomClasses(courseSelected);
      this.data = {
        id: newVal.details.id,
        name: newVal.details.name,
        photo: newVal.details.photo,
        dob: newVal.details.dob,
        gender: newVal.details.gender,
        class: newVal.acc.class,
        course: newVal.acc.course,
        entryStatus: newVal.acc.entry_status,
        logid: newVal.acc.id,
        resident: newVal.details.resident,
        gemail: newVal.details.gemail,
        gcontact: newVal.details.gcontacts,
        guardian: newVal.details.guardian,
        oldfile: newVal.details.photo,
        stdContact: newVal.details.contact,
        occupation: newVal.details.occupation,
        email: newVal.details.email,
        address: newVal.details.address,
      };
    },
  },
  methods: {
    ...mapActions({
      FetchAllStudentDetails: "students/fetchAllStudentDetails",
      FetchStudents: "students/fetchStudents",
      EditStudent: "students/editStudent",
      FetchClasses: "classes/fetchClasses",
      FetchStreams: "classes/fetchStreams",
      FetchCustomClasses: "classes/fetchCustomClasses",
      FetchCourses: "classes/fetchCourses",
    }),

    //Handling student's photo
    handleFileUpload(event) {
      this.data.photo = event.target.files[0];
    },

    resetError() {
      this.errors.name = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.resetError();
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingStudent = this.AllStudents.filter((student) => {
          return student.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingStudent.length) {
          this.errors.name = this.data.name + " Already Exists";
        } else {
          this.errors.name = "";
        }
      } else {
        this.existingStudent = [];
      }
    },
    editStd() {
      let studentEdit = new FormData();
      this.data.photo
        ? studentEdit.append("photo", this.data.photo)
        : studentEdit.append("photo", "");
      //setting up form data for the uploads
      studentEdit.append("id", this.data.id);
      studentEdit.append("name", this.data.name);
      studentEdit.append("photo", this.data.photo);
      studentEdit.append("dob", this.data.dob);
      studentEdit.append("gender", this.data.gender);
      studentEdit.append("class", this.data.class);
      studentEdit.append("course", this.data.course);
      studentEdit.append("entryStatus", this.data.entryStatus);
      studentEdit.append("resident", this.data.resident);
      studentEdit.append("gemail", this.data.gemail);
      studentEdit.append("gcontact", this.data.gcontact);
      studentEdit.append("guardian", this.data.guardian);
      studentEdit.append("oldfile", this.data.oldfile);
      studentEdit.append("logid", this.data.logid);
      studentEdit.append("stdContact", this.data.stdContact);
      studentEdit.append("occupation", this.data.occupation);
      studentEdit.append("email", this.data.email);
      studentEdit.append("address", this.data.address);

      this.EditStudent({
        student_details: studentEdit,
      });
    },

    fetchLevelinCourse() {
      const courseSelected = {
        course: this.data.course,
      };
      //fetching levels in course
      this.FetchCustomClasses(courseSelected);
    },
  },
  created() {
    this.FetchAllStudentDetails(this.$route.params.id);
    this.FetchStudents();
    this.FetchCourses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('edit_student')
        )
      "
    >
      <div class="col-12">
        <div class="card row">
          <form action="" @submit.prevent="editStd()">
            <div class="card-body col-11 mx-auto row">
              <div class="col-12">
                <strong class="text-primary">Accademic Details </strong>
                <hr />
              </div>
              <div class="form-group col-md-6 mb-3">
                <label>Student Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Student's Name"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.name"
                    required
                  />
                </div>
                <div class="text-danger" v-if="errors.name">
                  <em>{{ errors.name }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 row mb-3">
                <div class="col-md-8">
                  <label>Student's Photo</label>
                  <small class="text-primary"> (Optional) </small>
                  <div class="input-group">
                    <input
                      @change="handleFileUpload($event)"
                      class="form-control"
                      type="file"
                      accept="image/*"
                      id="student-photo"
                    />
                  </div>
                  <div class="text-danger" v-if="errors.photo">
                    <em>{{ errors.photo }}</em>
                  </div>
                </div>
                <div class="col-md-4">
                  <img
                    :src="sysConstants.url + 'students/' + data.oldfile"
                    alt="..."
                    height="500px"
                    class="img-thumbnail"
                    style="height: 70px; border-radius: 50%"
                  />
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Gender</label>
                <div class="input-group">
                  <select required v-model="data.gender" class="form-control">
                    <option selected value="" disabled>Select Gender</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div class="text-danger" v-if="errors.gender">
                  <em>{{ errors.gender }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Date of Birth</label>
                <div class="input-group">
                  <b-form-input
                    id="dob"
                    v-model="data.dob"
                    name="dob"
                    type="date"
                    required
                  ></b-form-input>
                </div>
                <div class="text-danger" v-if="errors.dob">
                  <em>{{ errors.dob }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Assign Course</label>
                <div class="input-group">
                  <select
                    @change="fetchLevelinCourse()"
                    required
                    v-model="data.course"
                    class="form-control"
                  >
                    <option v-if="SaveStatus" selected value="" disabled>
                      Fetching Courses...
                    </option>
                    <option v-else selected value="" disabled>
                      Select Course
                    </option>
                    <option
                      v-for="(course, index) in AllCourses"
                      :key="index"
                      :value="course.id"
                    >
                      {{ course.name }}
                    </option>
                  </select>
                </div>
                <div class="text-danger" v-if="errors.course">
                  <em>{{ errors.course }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Assign Level</label>
                <div class="input-group">
                  <select required v-model="data.class" class="form-control">
                    <option v-if="SaveStatus" selected value="" disabled>
                      Fetching Level...
                    </option>
                    <option v-else selected value="" disabled>
                      Select Level
                    </option>
                    <option
                      v-for="(classes, index) in CustomClasses"
                      :key="index"
                      :value="classes.id"
                    >
                      {{ classes.short }}
                    </option>
                  </select>
                </div>
                <div class="text-danger" v-if="errors.class">
                  <em>{{ errors.class }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Entry Status</label>
                <div class="input-group">
                  <select
                    required
                    v-model="data.entryStatus"
                    class="form-control"
                  >
                    <option selected value="" disabled>Select Status</option>
                    <option value="2">New Student</option>
                    <option value="1">Continuing Student</option>
                  </select>
                </div>
                <div class="text-danger" v-if="errors.entryStatus">
                  <em>{{ errors.entryStatus }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Contact Number(s)</label>
                <small class="text-primary"> (Optional) </small>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Contact"
                    class="form-control"
                    v-model="data.stdContact"
                  />
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Occupation</label>
                <small class="text-primary"> (Optional) </small>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Occupation"
                    class="form-control"
                    v-model="data.occupation"
                  />
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Email </label>
                <small class="text-primary"> (Optional) </small>
                <div class="input-group">
                  <input
                    type="email"
                    placeholder="Enter Student's Email"
                    class="form-control"
                    v-model="data.email"
                  />
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Student Address </label>
                <small class="text-primary"> (Optional) </small>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Address"
                    class="form-control"
                    v-model="data.address"
                  />
                </div>
              </div>

              <div class="col-12 mt-3">
                <strong class="text-primary">Parents Details</strong>
                <hr />
              </div>
              <div class="form-group col-md-6 mb-3">
                <label>Gurdian/Parent Name</label>
                <div class="input-group">
                  <input
                    type="text"
                    placeholder="Enter Gurdian/Parent Name"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.guardian"
                    required
                  />
                </div>
                <div class="text-danger" v-if="errors.gurdian">
                  <em>{{ errors.gurdian }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>
                  Guadian/Parent Email
                  <small class="text-primary"> (Optional) </small>
                </label>
                <div class="input-group">
                  <input
                    type="email"
                    placeholder="Enter Gurdian/Parent Email"
                    class="form-control"
                    @keyup="checkName"
                    @input="resetError"
                    v-model="data.gemail"
                  />
                </div>
                <div class="text-danger" v-if="errors.gemail">
                  <em>{{ errors.gemail }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Residents of </label>
                <small class="text-primary">
                  (Give a list e.g District, County, ...)
                </small>
                <textarea
                  v-model="data.resident"
                  class="form-control"
                  :maxlength="100"
                  rows="2"
                  required
                  placeholder="Enter a list with comma seperations"
                ></textarea>
                <div class="text-danger" v-if="errors.resident">
                  <em>{{ errors.resident }}</em>
                </div>
              </div>

              <div class="form-group col-md-6 mb-3">
                <label>Parent/Gurdian contacts</label>
                <small class="text-primary">
                  (List the contacts e.g 07..., 07...)
                </small>
                <textarea
                  v-model="data.gcontact"
                  class="form-control"
                  :maxlength="30"
                  rows="2"
                  required
                  placeholder="Enter a list with comma seperations e.g 07..., 07..."
                ></textarea>
                <div class="text-danger" v-if="errors.gcontact">
                  <em>{{ errors.gcontact }}</em>
                </div>
              </div>
              <div class="col-12">
                <hr />
              </div>
              <div class="col-12">
                <button
                  v-if="SaveStatus"
                  type="submit"
                  disabled
                  class="btn btn-success btn-sm float-end"
                >
                  <b-spinner variant="light" small label="Spinning"></b-spinner>
                  Updating Student...
                </button>
                <button
                  v-else
                  type="submit"
                  class="btn btn-outline-success btn-sm float-end"
                >
                  <i class="fa fa-save"></i>
                  Update Student
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
